(() => {
  'use strict';
  const number = new Intl.NumberFormat('tr-TR', {minimumFractionDigits:2,maximumFractionDigits:2});
  function formatPrices(root=document) {
    root.querySelectorAll('[data-melco-price]').forEach(el => {
      const value=Number(el.dataset.melcoPrice),max=Number(el.dataset.melcoPriceMax);
      if(!Number.isFinite(value)||value<=0)return;
      const currency=el.dataset.melcoCurrency==='TRY'?'TL':el.dataset.melcoCurrency;
      el.textContent=number.format(value/100)+(Number.isFinite(max)&&max>value?' – '+number.format(max/100):'')+' '+currency;
    });
  }
  formatPrices();
  document.addEventListener('shopify:section:load',event=>formatPrices(event.target));
  document.addEventListener('click',event=>{
    const opener=event.target.closest('[data-melco-help-open]');
    if(opener){
      const dialog=document.getElementById(opener.getAttribute('aria-controls'));
      if(dialog instanceof HTMLDialogElement){dialog.showModal();dialog.addEventListener('close',()=>opener.focus(),{once:true});}
    }
    const closer=event.target.closest('[data-melco-help-close]');
    if(closer)closer.closest('dialog').close();
    if(event.target.matches('dialog.m7-help-dialog')){
      const bounds=event.target.getBoundingClientRect();
      if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)event.target.close();
    }
  });
})();
